import React from 'react';

const TabThursday = () => {
  return (
    <div className="flex flex-col w-full">
      <div className="flex border-b border-gray-300 py-3">
        <button className="text-green-100 tracking-0-28 ml-2">
          <span className="text-2xl">+</span> Slot Baru
        </button>
      </div>
      <div className="flex border-b border-gray-300 py-3 justify-between">
        <p className="text-font-gray">07:00 - 08:00</p>
        <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
          <input
            type="checkbox"
            name="toggle"
            id="toggle"
            className="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
          />
          <label
            for="toggle"
            className="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
          ></label>
        </div>
      </div>
      <div className="flex border-b border-gray-300 py-3 justify-between">
        <p className="text-font-gray">08:00 - 09:00</p>
        <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
          <input
            type="checkbox"
            name="toggle"
            id="toggle"
            className="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
          />
          <label
            for="toggle"
            className="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
          ></label>
        </div>
      </div>
    </div>
  );
};

export default TabThursday;
